import React from "react";
import { Container, Heading, SubHeading,Logo ,InfoContainer,Frame,Line} from "./styles/clients";

export default function Clients({ children, ...restProps }) {
  return <Container {...restProps}> {children} </Container>;
}

Clients.Heading = function ClientsHeading({ children, ...restProps }) {
  return <Heading {...restProps}>{children}</Heading>;
};

Clients.SubHeading = function ClientsSubHeading({ children, ...restProps }) {
  return <SubHeading {...restProps}>{children}</SubHeading>;
};

Clients.Logo = function ClientsLogo({children, ...restProps}){
  return <Logo {...restProps} />
}

Clients.InfoContainer = function ClientsInfoContainer({children, ...restProps}){
  return <InfoContainer {...restProps}>{children}</InfoContainer>
}

Clients.Frame = function ClientsFrame({children, ...restProps}){
  return <Frame {...restProps}>{children}</Frame>
}

Clients.Line = function ClientsLine({children, ...restProps}){
  return <Line {...restProps}>{children}</Line>
}